/**
 * Which profile tile holds a form field. Used to open the tile of the first
 * field that failed validation and to mark tiles with unsaved changes.
 *
 * @param {Array<string|number>} name - Form name path, e.g. ['generalData', 'city']
 * @returns {string} Tile id
 */
export const sectionOfField = (name = []) => {
  const [group, key] = name;
  if (group === 'additionalPersonalInfo') {
    return [
      'previousEmployments',
      'workExperience',
      'workExperienceStartDate',
    ].includes(key)
      ? 'staz'
      : 'licno';
  }
  if (group === 'generalData') {
    if (['bankName', 'bankAccounts', 'isResident'].includes(key))
      return 'isplata';
    if (['position', 'positionEng', 'jobPosition', 'orgUnit'].includes(key))
      return 'org';
    if (key === 'otherRemarks') return 'napomene';
    return 'licno';
  }
  if (group === 'employmentSettings') {
    if (key === 'isHrOfficer') return 'org';
    if (['shiftWorker', 'workTimeType', 'workTimeCustomType'].includes(key))
      return 'vreme';
    return 'ugovor';
  }
  if (group === 'allowances')
    return key === 'defaultTimesheetComment' ? 'napomene' : 'primanja';
  if (group === 'otherAllowances') return 'primanja';
  if (group === 'holidayLeaveCalculation') return 'go';
  if (group === 'specialAbsence') return 'vreme';
  if (group === 'company' || group === 'employeeSector') return 'org';
  if (group === 'status' || group === 'effectiveDate') return 'ugovor';
  return 'licno';
};

// Tiles of the profile page whose content is (partly) the employee form.
export const PROFILE_FORM_SECTIONS = [
  'licno',
  'isplata',
  'ugovor',
  'org',
  'vreme',
  'primanja',
  'staz',
  'go',
  'dok',
  'napomene',
];
